// extracted by mini-css-extract-plugin
export default {"ClientDashboardPage":"ClientDashboardPage_ClientDashboardPage__R627G"};